import React, { useEffect, useState } from 'react';
import useRequest from '../../../hooks/useRequest';
import { Card } from '../Card/Card';
import { BASE_URL, FAVORITE, FAVORITES, ORDER_AGAIN, RECOMMENDATIONS } from '../../../constants/App';
import CustomSlider from '../CustomSlider/CustomSlider';
import './MenuPersonalization.scss';
import useStore from '../../../store/useStore';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { getStoreIDByURL, updateOrderViewModel } from '../../../Utils/componentUtils';
import { componentRenderCheck, multipleAndCheck, multipleOrCheck, ternaryCheck } from '../../../Utils/WindowUtils';
import OrderAheadPopup from '../CreateCart/OrderAheadPopup';
import { productString } from '../../Analytics/AnalyticsNew';
import ButtonSegments from '../../Atoms/Button/ButtonSegments';
import Skeleton from '../../Templates/Skeleton/Skeleton';
import Heading from '../../Atoms/Heading/Heading';
import { ADD_TO_BAG, ONETOUCH_PRODUCT_ADDED } from '../../../constants/AnalyticsConstants';
import CartModal from '../CartModal/CartModal';
import Link from '../../Atoms/Link/Link';
import UseWindowWidth from '../../../hooks/useWindowWidth';
import { getProductsItems, setDeliveryAddressIfNotMerged } from '../../Organisms/RecentOrdersList/RecentOrderUtils';
import classNames from 'classnames';
import InfoModal from '../CartModal/InfoModal';
import { getLocalTime, getProductList } from '../../../Utils/analyticsUtils';
import { saveCartQuantity } from '../../../Utils/OrderViewModelUtils';


interface MenuPersonalizationProps {
  apiEndpoint: { value: string };
  dataSource: string;
  params: { CacheDuration: string | number };
  siteName: string;
  favoritesDataSource: { id: string };
  orderAgaainDataSource: { id: string };
  categoryId: { value: string };
  orderViewModel: any;
}

const MenuPersonalization: React.FC<MenuPersonalizationProps> = ({
  apiEndpoint,
  dataSource,
  params,
  siteName,
  favoritesDataSource,
  orderAgaainDataSource,
  categoryId,
  orderViewModel
}) => {
  const [storeCloseOApopupData, setStoreCloseOApopupData] = useState();
  const [showStoreCloseOApopup, setShowStoreCloseOApopup] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [activeData, setActiveData] = useState<any>();
  const [unavailableData, setUnavailableData] = useState<any>(null);
  const [unavailableDictionary, setUnavailableDictionary] = useState<any>({});
  const [unavailableApiEndPoint, setUnavailableApiEndPoint] = useState<string>('');
  const [item, setItem] = useState<any>();
  const [isPlusIconLottieCircle, setIsPlusIconLottieCircle] = React.useState(false);
  const [error, setError] = useState<any>({});
  const [isModal, setIsModal] = useState<boolean>(false);
  const [storeClose, setStoreClose] = useState<boolean>(false);
  const [deliveryAddress, setDeliveryAddress] = React.useState<any>({});
  const [isItemAvailable, setIsItemAvailable] = React.useState<boolean>(false);
  const [errorOrderHistoryList, setErrorOrderHistoryList] = useState<any>({});

  const {
    headerHeightCal: headerHeight,
    setContextCardLoader,
    setAttemptTracker,
    setAnalyticsProducts,
    setSelectedCard,
    setCartQuantity,
    contextCardLoader,
    isSetFavourite,
    pageLoadAnalytics,
    setPageLoadAnalytics,
    setTotalCards,
  } = useStore();
  const { data, isLoading, error: pageLoadErrorRes } = useRequest({
    params: {
      apiEndpoint: apiEndpoint.value,
      StoreId: orderViewModel?.store?.id ?? orderViewModel?.store?.StoreId,
      SiteName: siteName,
      FavoritesDatasourceId: favoritesDataSource?.id,
      IsDefaultStoreId: true,
      CultureCode: orderViewModel.headerFooterLanguageCode,
      SelectedStoreId: orderViewModel?.store?.id ?? orderViewModel?.store?.StoreId,
      CategoryId: categoryId?.value,
      cacheDuration: params.CacheDuration,
      BestSellerDatasourceId: dataSource,
      OrderAgainDataSourceId: orderAgaainDataSource?.id,
      IsJsonResponse: true,
      OneTrustActiveGroups: (window as any).OnetrustActiveGroups,
    },
  });
  const { postRequest: mutateData } = useRequest({ isOnClick: true });
  const { postRequest: orderHistoryStoreValidationPayload } = useRequest({ isOnClick: true });
  const { postRequest: mutateDataRecomendation } = useRequest({ isOnClick: true });
  const dataKeyList = data ? Object.keys(data) : [];
  const dataNodeCount = dataKeyList.length;
  const windowWidth = UseWindowWidth();

  useEffect(() => {
    if (!_isEmpty(data)) {
      const keyName = dataKeyList[activeIndex];
      setActiveData(_get(data, [keyName], {}));
      setPageLoadAnalytics(pageLoadAnalytics + 1);
    }
    if (!_isEmpty(pageLoadErrorRes)) {
      const apiErrors = _get(pageLoadErrorRes, ['response', 'data', 'error'], null);
      if (apiErrors) {
        setErrorOrderHistoryList(apiErrors);
      }
    }
  }, [data, activeIndex]);

  useEffect(() => {
    if (_isEmpty(data)) return;

    const algorithmList: string[] = [];
    const productStreamParts: string[] = [];

    for (let i = 0; i < dataNodeCount; i++) {
      const keyName = dataKeyList[i];
      const currentData = _get(data, [keyName], {});
      const categoryTypeEnglish = _get(currentData, 'categoryType', '')?.toLowerCase();

      if (categoryTypeEnglish) {
        productStreamParts.push(categoryTypeEnglish);
      }

      const products = currentData?.productsList ?? [];
      products.forEach((element: any) => {
        if (element?.algorithm) {
          algorithmList.push(element.algorithm);
        }
      });
    }

    const productStreamValue = productStreamParts.join('_');
    const algorithmValue = algorithmList.join('|');

    setAnalyticsProducts({
      recCriteria: algorithmValue,
      productStream: productStreamValue,
    });
  }, [data]);

  let additionalPayloadForDelivery = {};
  if (multipleOrCheck(orderViewModel.orderType == 'delivery', orderViewModel.orderType == 'Delivery')) {
    additionalPayloadForDelivery = {
      StreetAddressLine1: orderViewModel.DeliveryAddress?.StreetAddressLine1,
      StreetAddressLine2: orderViewModel.addressData?.StreetAddressLine2,
      City: orderViewModel.DeliveryAddress?.City,
      State: orderViewModel.DeliveryAddress?.State,
      Zip: orderViewModel.DeliveryAddress?.Zip,
      Country: orderViewModel.DeliveryAddress?.Country,
    }
  }

  const lastOrderType = ternaryCheck(
    multipleOrCheck(window.orderViewModel?.orderType === null,
      window.orderViewModel?.orderType === undefined,
      window.orderViewModel?.orderType === ""),
    window.orderViewModel?.lastOrderFulfillmentType,
    window.orderViewModel?.orderType);

  const getCartItemIdForLottie = (card: any, index: number) => {
    if (activeData?.categoryType === FAVORITES) {
      return `${card?.cartItemId}-${index}`;
    }
    if (activeData?.categoryType === ORDER_AGAIN) {
      return `${card?.orderId}-${index}`;
    }
    if (activeData?.categoryType === RECOMMENDATIONS) {
      return `${card?.productId}-${index}`
    }
  };

  const renderCards = (dataLists: any) => {
    return dataLists?.map((card: any, index: number) => (
      <Card
        key={_get(card, 'productId', `unique-${index}`)}
        title={card?.favoriteName ?? _get(card, 'productName', '')}
        imageURL={_get(card, 'image', '')}
        redirectURL={_get(card, 'url', '')}
        MenuListTag={'button'}
        onAnchorClick={(e: React.SyntheticEvent) => onAnchorClick(e, card, index)}
        productName={_get(card, 'productName', '')}
        index={_get(card, 'productId', '')}
        cartItemId={getCartItemIdForLottie(card, index)}
        showPlusIcon={card?.isQuickSell &&
          (contextCardLoader?.cardId !== getCartItemIdForLottie(card, index))
        }
        isPlusIconLottieCircle={isPlusIconLottieCircle}
        plusIconHandler={(e: React.SyntheticEvent) => {
          e.stopPropagation();
          onClickHandler(card, index)
        }}
        {...!_isEmpty(_get(card, 'productReadyDatetime', '')) && {
          description:
            <p className={'ordered-date'}>
              <span>{_get(card, 'orderedText', '')}: </span>
              {_get(card, 'productReadyDatetime', '')}
            </p>
        }}
        recommendedBadge={{
          text: card?.bannerText,
          textColor: card?.bannerTextColor,
          backgroundgcolor: card?.bannerColor,
        }}
        isFavourite={multipleAndCheck(activeData?.categoryType === FAVORITES,
          !_isEmpty(card?.favoriteName))}
        cardTextData={[
          { key: 'addToBag', value: 'Add to Bag'},
        ]}
      ></Card>
    ));
  };

  const getItemPayload = (cardItem: any) => {
    return {
      AddCartItems: [
        {
          analytics: {
            CategoryId: cardItem?.analytics?.categoryId,
            CategoryName: cardItem?.analytics?.categoryName,
            ProductName: cardItem?.analytics?.productName,
            IsCookie: cardItem?.analytics?.isCookie,
            masterProductId: cardItem?.analytics?.masterProductId,
            ProductOriginSource: ternaryCheck(activeData?.categoryType === RECOMMENDATIONS, 'regular', 'recent order'),
            ComboOriginSource: "n/a",
            SubCategory: cardItem?.analytics?.subCategory,
            Size: cardItem?.analytics?.size,
            isSoup: cardItem?.analytics?.isSoup,
          },
          options: cardItem?.options1 || [],
          productId: cardItem?.productId,
          productName: cardItem?.productName,
          quantity: 1,
          imageUrl: '/ns/images/Menu/USA/ENG/Category_767x767_BlackForestHam_Sandwiches_@1x.jpg',
        },
      ],
    };
  }
  const getAddItemModelPayload = (cardItem: any) => {
    return {
      IsReactResponse: true,
      items: getItemPayload(cardItem),
      bundles: null,
      CartId: orderViewModel.currentOrder.cartId,
      StoreId: orderViewModel.store.id,
      LocationId: cardItem?.locationId ?? orderViewModel.store.id,
      IsKidsMeal: cardItem?.isKidsMeal,
      pricingScheme: '1',
      fulfillmentType: orderViewModel.orderType ?? activeData?.fulfillmentType,
      dineIn: false,
      curbside: {
        curbsideInstructions: ' ',
      },
      orderInstructions: ' ',
      siteName: siteName,
    };
  }
  const reOrderOrderAgain = async (cardItem: any, index: number) => {
    setIsPlusIconLottieCircle(true);
    setContextCardLoader({
      cardId: `${cardItem?.orderId}-${index}`,
    });

    const finalPayload = {
      ...additionalPayloadForDelivery,
      IsJsonResponse: true,
      AddItemModel: {
        ...getAddItemModelPayload(cardItem),
        Delivery: ternaryCheck(
          multipleOrCheck(orderViewModel.orderType == 'delivery', orderViewModel.orderType == 'Delivery'),
          {
            DeliveryAddress: additionalPayloadForDelivery,
            QuoteId: orderViewModel.DeliveryAddress?.QuoteId,
          },
          null),
      },
      CartId: cardItem?.cartItemId ?? cardItem?.orderId,
      DatasourceId: orderAgaainDataSource?.id,
      IsAccordionOpen: false,
      IsAddToBag: false,
      IsAddToBagFromRecentOrder: true,
      IsModalView: true,
      IsRecentOrder: false,
      MergeCart: orderViewModel.currentOrder.cartQuantity > 0,
      OrderId: cardItem?.orderId,
      OrderType: orderViewModel.orderType,
      ProductId: cardItem?.productId,
      SiteName: siteName,
      StoreId: orderViewModel?.store?.id ?? orderViewModel?.store?.StoreId,
      apiEndpoint: _get(activeData, 'apiEndPoint', ''),
    };
    const mergeCart = ternaryCheck(Number(orderViewModel.currentOrder.cartQuantity) > 0, true, false);
    await orderHistoryStoreValidationPayload(finalPayload).then((orderHistoryValidationData: any) => {
      setContextCardLoader({
        cardId: '',
      });
      if (!_isEmpty(_get(orderHistoryValidationData, ["storeError", "createStoreErrorData"], {}))) {
        setStoreCloseOApopupData(_get(orderHistoryValidationData, ["storeError", "createStoreErrorData"], {}));
        setShowStoreCloseOApopup(true);
        return;
      }
      if (multipleAndCheck(
        _isEmpty(orderHistoryValidationData?.storeError?.createStoreErrorData),
        !_isEmpty(orderHistoryValidationData),
        !_isEmpty(orderHistoryValidationData?.listOfUnavailableModalData))) {
        setUnavailableApiEndPoint(_get(activeData, ["unavailableReorderApiEndPoint"], "/remoteorder/orders/reordercart"));
        setDeliveryAddressIfNotMerged(mergeCart, setDeliveryAddress, orderHistoryValidationData);
        setIsItemAvailable(_get(orderHistoryValidationData, ['listOfUnavailableModalData', 'isItemAvailable'], false));
        setUnavailableDictionary(_get(orderHistoryValidationData, ['listOfUnavailableModalData', 'dictionaryLables'], {}));
        setUnavailableData(_get(orderHistoryValidationData, ['listOfUnavailableModalData', 'recentOrderItems'], []));
        setIsModal(true);
      }
      if (!_isEmpty(orderHistoryValidationData?.addToBagResponse)) {
        orderViewModel.comboSource = null;
        orderViewModel.save();
        const { responseBody } = orderHistoryValidationData?.addToBagResponse;
        if (!_isEmpty(responseBody?.error)) {
          setErrorOrderHistoryList(responseBody.error);
          return;
        }
        updateOrderViewModel(orderViewModel, responseBody);

        const productStringData = getProductsItems([responseBody.cartCurrentItem]);
        const updatedProductStringWithAddTobagSource = productStringData.map((product: any) => {
          product.addToBagSource = ternaryCheck(!_isEmpty(cardItem?.bannerText),
            'menu:order again:recommendations',
            'menu:order again'
          );
          product.badgeName = cardItem?.bannerText ?? '';
          product.productBadgeColor = cardItem?.bannerColor ?? '';
          return product;
        })
        const toastedEvent = _get(productStringData, [0, 'ingredients', 'breadType'], []);
        const upsellProductEvent = _get(productStringData, [0, 'additionalItem'], {});

        setAnalyticsProducts({
          toastedEvent: ternaryCheck(toastedEvent.length > 0, 1, 0),
          upsellProductAddedEvent: ternaryCheck(!_isEmpty(upsellProductEvent), 1, 0),
          cartOpen: ternaryCheck(multipleOrCheck(orderViewModel.cartOpen, !orderViewModel.currentOrder.cartId), 1, 0),
          itemAddedtoBag: 1,
          productPriceAdded: 1,
          productQuantityAdded: 1,
          MIAMPriceAdded: 1,
          ExtrasPriceAdded: 1,
          ComboPriceAdded: 1,
          CYO: ternaryCheck(orderViewModel?.headerFooterLanguageCode.indexOf('pr') > 0, 1, 0),
          cartID: orderViewModel?.currentOrder?.cartId,
          orderSourceType: 'recent order',
          products: updatedProductStringWithAddTobagSource ?? [],
          clickActionName: ONETOUCH_PRODUCT_ADDED,
          componentTitle: 'order again',
          recCriteria: _get(cardItem, ['algorithm'], ''),
        });
        setAttemptTracker([{ name: ADD_TO_BAG }]);
        setCartQuantity(responseBody.cartQuantity);
        setTimeout(() => {
          localStorage.setItem("cartProgressBar", responseBody.cartQuantity);
        }, 1000);
        orderViewModel.cartOpen = false;
        orderViewModel.save();
      }
    })
      .catch((orderHistoryValidationError: any) => {
        setContextCardLoader({
          cardId: '',
        });
        setError(orderHistoryValidationError);
        setIsModal(true);
      });

  }

  const storeCloseOApopupClose = () => {
    setShowStoreCloseOApopup(false);
  }
  const getTabButtonData = (tabCount: number) => {
    const buttonDataList = [];
    if (!_isEmpty(data)) {
      for (let i = 0; i < tabCount && i < dataNodeCount; i++) {
        const keyName = dataKeyList[i];
        buttonDataList.push({
          title: _get(data, [keyName, 'title'], ''),
          icon: _get(data, [keyName, 'icon'], ''),
        });
      }
    }
    return buttonDataList;
  }
  const tabButtonData = getTabButtonData(2);

  const handleTabClick = (index: number) => {
    setActiveIndex(index);
    const keyName = dataKeyList[index];
    const clickedTabData = _get(data, [keyName], {});
    const clickedTypeEnglish = _get(clickedTabData, 'categoryType', '')?.toLowerCase();
    setAnalyticsProducts({
      clickActionName: clickedTypeEnglish,
      componentTitle: 'tab',
    });
    setAttemptTracker([{ name: "menu", isClickable: true }]);
  }

  const onAnchorClick = (e: React.SyntheticEvent, details: any, index: number) => {
    e.stopPropagation();
    if (!_isEmpty(details?.url)) {
      setSelectedCard(index + 1);
      setTotalCards(_get(activeData, ['productsList'], []).length);
      setAnalyticsProducts({
        clickActionName: details.productName,
        componentTitle: _get(activeData, 'categoryType', ''),
      });
      setAttemptTracker([{ name: 'menu', isClickable: true }]);

      setTimeout(() => {
        window.location.href = BASE_URL + details?.url;
      }, 100);
    }
  };

  const onClickHandler = (cardItem: any, index: number) => {
    setSelectedCard(index + 1);
    setTotalCards(_get(activeData, ['productsList'], []).length);
    setItem(cardItem);
    if (!_isEmpty(activeData?.createStoreErrorData) &&
      (window.orderViewModel.currentOrder.cartId === null ||
        window.orderViewModel.currentOrder.cartId === undefined ||
        window.orderViewModel.currentOrder.cartId === "")
      && lastOrderType === 'delivery') {
      setStoreCloseOApopupData(_get(activeData, ["createStoreErrorData"], {}));
      setShowStoreCloseOApopup(true);
      return;
    }
    const categoryTypeEnglish = _get(activeData, 'categoryType', '')?.toLowerCase();
    if (categoryTypeEnglish === ORDER_AGAIN) {
      reOrderOrderAgain(cardItem, index);
    }
    if (categoryTypeEnglish === FAVORITES) {
      reOrderFavorites(cardItem, index);
    }
    if (categoryTypeEnglish === RECOMMENDATIONS) {
      recommandationAddToBag(cardItem, index);
    }
  }

  // These we need for fav click
  const reOrderFavorites = async (cardItem: any, index: number) => {
    setIsPlusIconLottieCircle(true);
    setContextCardLoader({
      cardId: `${cardItem?.cartItemId}-${index}`,
    });

    await mutateData({
      StoreId: orderViewModel?.store?.id ?? orderViewModel?.store?.StoreId ?? getStoreIDByURL(),
      CurrentOrderCartId: orderViewModel?.currentOrder?.cartId,
      ReorderedItemCartItemId: cardItem?.cartItemId,
      SiteName: siteName,
      IsReactResponse: true,
      OrderSourceType: FAVORITE,
      ComboOriginSource: isSetFavourite ? 'n/a' : null,
      FavoritesDatasourceId: favoritesDataSource?.id,
      apiEndpoint: _get(activeData, 'apiEndPoint', ''),
    })
      .then((res: any) => {
        setContextCardLoader({
          cardId: '',
        });
        if (!_isEmpty(_get(res, ["storeError", "createStoreErrorData"], {}))) {
          setStoreCloseOApopupData(_get(res, ["storeError", "createStoreErrorData"], {}));
          setShowStoreCloseOApopup(true);
          return;
        }
        if (res) {
          reOrderFavDetails(res, cardItem);
        }
      })
      .catch((e: { [key: string]: string }) => {
        if (e) {
          setContextCardLoader({
            cardId: '',
          });
          setAnalyticsProducts({
            componentTitle: FAVORITE,
            clickActionName: cardItem?.productName,
          });
          setAttemptTracker([{ name: "menu", isClickable: true }]);
          setError(e);
          setStoreClose(false);
          setUnavailableDictionary({});
          setUnavailableData(null);
          setIsModal(true);
        }
      });
  };

  const reOrderFavDetails = (res: any, cardItem: any) => {
    const isRecommended = !_isEmpty(cardItem?.bannerText);
    const favoriteData = _get(res, ['favorites', 0]);
    const successData = _get(res.responseBody, 'successUrl');
    const dictonaryData = _get(res, 'dictionaryLables', {});
    if (favoriteData && dictonaryData) {
      setUnavailableData(favoriteData);
      setUnavailableDictionary(dictonaryData);
      setStoreClose(false);
      setError({});
      setUnavailableApiEndPoint(res.unavailableApiEndPoint);
      setAnalyticsProducts({ componentTitle: FAVORITE, clickActionName: favoriteData.productName });
      setAttemptTracker([{ name: 'menu', isClickable: true }]);
      setIsModal(true);
    }

    if (favoriteData) {
      const isAvailable = favoriteData.isAvailable;
      const ingredientsAvailable = favoriteData.areAllIngredientsAvailable;
      if (multipleAndCheck(isAvailable, ingredientsAvailable)) {
        window.location.href = `/${orderViewModel.headerFooterLanguageCodeRedirect}/locator`;
      }
    }

    if (successData) {
      const productDetails = {
        categoryName: res.responseBody.cartCurrentItem.analytics.categoryName,
        productName: res.responseBody.cartCurrentItem.analytics.productName,
        productId: _get(res, ['responseBody', 'cartCurrentItem', 'productId'], ''),
        price: res.responseBody.cartCurrentItem.totalLineItemPrice,
        quantity: res.responseBody.cartCurrentItem.quantity,
        size: res.responseBody.cartCurrentItem.productName,
      };
      const addToBagSource = ternaryCheck(isRecommended,
        'menu:favorites:recommendations',
        'menu:favorites')
      const productStringData = productString(
        res.responseBody.cartCurrentItem,
        productDetails,
        '',
        addToBagSource,
        'favorite',
      );
      const toastedEvent = _get(productStringData, [0, 'ingredients', 'breadType'], []);
      orderViewModel.currentOrder.cartId = orderViewModel.currentOrder.cartId ?? res.responseBody.cartId;
      reOrderSetAnalytice(toastedEvent, productStringData, _get(cardItem, ['algorithm'], ''));
      orderViewModel.cartOpen = false;
      orderViewModel.save();
      updateOrderViewModel(orderViewModel, res.responseBody);
      setCartQuantity(res.responseBody.cartItemQuantity || res.responseBody.cartQuantity);
      localStorage.setItem('cartProgressBar', res.responseBody.cartQuantity);
    }
  };
  const reOrderSetAnalytice = (toastedEvent: any, productStringData: any, algorithm: string) => {
    const updatedProductStringWithBadge = productStringData.map((product: any) => {
      product.badgeName = item?.bannerText ?? '';
      product.productBadgeColor = item?.bannerColor ?? '';
      return product;
    });
    setAnalyticsProducts({
      toasted: ternaryCheck(toastedEvent.length > 0, 1, 0),
      upsellProductAddedEvent: 0,
      cartOpen: ternaryCheck(
        multipleOrCheck(orderViewModel?.cartOpen, !orderViewModel?.currentOrder?.cartId),
        1,
        0,
      ),
      cartID: orderViewModel.currentOrder.cartId,
      itemaddedtobag: 1,
      productPriceAdded: 1,
      productQuantityAdded: 1,
      ExtrasPriceAdded: 1,
      ComboPriceAdded: 1,
      MIAMPriceAdded: 1,
      products: updatedProductStringWithBadge ?? [],
      clickActionName: ONETOUCH_PRODUCT_ADDED,
      componentTitle: 'favorites',
      orderSourceType: FAVORITE,
      recCriteria: algorithm,
    });
    setAttemptTracker([{ name: ADD_TO_BAG }]);
  };

  const onCloseCartModal = () => {
    setAnalyticsProducts({});
    setIsModal(false);
  };

  const getViewAllBtn = () => {
    return (
      <Link
        href={ternaryCheck(activeData?.categoryType === FAVORITES,
          _get(activeData, ['dictionaryLables', 'viewAllLink'], ''),
          _get(activeData, ['dictionaryLables', 'viewOrderHistoryURL'], ''))}
        testAutoId={`view-all-cta-${activeData?.categoryType}`}
        className='view-all-cta'
        text={ternaryCheck(activeData?.categoryType === FAVORITES,
          _get(activeData, ['dictionaryLables', 'viewAll'], 'VIEW ALL'),
          _get(activeData, ['dictionaryLables', 'viewOrderHistorytext'], 'View Order History'))}

        onClick={(e: React.SyntheticEvent) => {
          e.stopPropagation();
          setAnalyticsProducts({
            clickActionName: ternaryCheck(activeData?.categoryType === FAVORITES,
              'view all',
              'view order history'),
            componentTitle: "",
          });
          setAttemptTracker([{ name: 'menu', isClickable: true }]);
        }}

      />
    );
  }

  const recommandationAddToBag = async (cardItem: any, index: number) => {
    setIsPlusIconLottieCircle(true);
    setContextCardLoader({
      cardId: `${cardItem?.productId}-${index}`,
    });
    await mutateDataRecomendation({
      apiEndpoint: _get(activeData, 'apiEndPoint', ''),
      StoreId: orderViewModel?.store?.id,
      LocationId: orderViewModel?.store?.id,
      CartId: orderViewModel?.currentOrder?.cartId,
      pricingScheme: '1',
      fulfillmentType: orderViewModel?.orderType ?? 'pickup',
      dineIn: false,
      DatasourceId: '',
      IsQuickaddon: false,
      IsReactResponse: true,
      IsQuickSell: cardItem.isQuickSell,
      IsSidekick: cardItem.isSideKick ?? false,
      curbside: {
        curbsideInstructions: ' ',
      },
      orderInstructions: ' ',
      sitename: siteName,
      Delivery:
        ternaryCheck(
          multipleOrCheck(orderViewModel.orderType == 'delivery', orderViewModel.orderType == 'Delivery'),
          {
            DeliveryAddress: additionalPayloadForDelivery,
            QuoteId: orderViewModel.DeliveryAddress?.QuoteId,
          },
          null),
      items: getItemPayload(cardItem),
      userLocalTime: getLocalTime(),
    }).then((addItemAsyc: any) => {
      if (addItemAsyc) {
        if (!_isEmpty(addItemAsyc?.storeError?.createStoreErrorData)) {
          setContextCardLoader({ cardId: '' });
          setStoreCloseOApopupData(_get(addItemAsyc, ["storeError", "createStoreErrorData"], {}));
          setShowStoreCloseOApopup(true);
          return;
        }
        saveCartQuantity(addItemAsyc.cartQuantity);
        setCartQuantity(addItemAsyc.cartQuantity);
        localStorage.setItem("cartProgressBar", addItemAsyc.cartQuantity);
        const productStringDataRecomm = getProductList([
          { ...addItemAsyc.cartCurrentItem, addToBagSource: 'menu:recommendations' },
        ]);
        const updatedProductStringWithBadge = productStringDataRecomm.map((product: any) => {
          product.badgeName = cardItem?.bannerText ?? '';
          product.productBadgeColor = cardItem?.bannerColor ?? '';
          return product;
        });
        setAnalyticsProducts({
          products: updatedProductStringWithBadge ?? [],
          clickActionName: ONETOUCH_PRODUCT_ADDED,
          cartOpen: ternaryCheck(
            multipleOrCheck(orderViewModel?.cartOpen, !orderViewModel?.currentOrder?.cartId),
            1,
            0,
          ),
          cartID: orderViewModel?.currentOrder?.cartId,
          itemaddedtobag: 1,
          productPriceAdded: 1,
          productQuantityAdded: 1,
          toasted: 0,
          ComboPriceAdded: 1,
          MIAMPriceAdded: 1,
          ExtrasPriceAdded: 1,
          recCriteria: _get(cardItem, ['algorithm'], ''),
          orderSourceType: 'regular',
          componentTitle: 'recommendations',
        });
        setAttemptTracker([{ name: ADD_TO_BAG }]);
        setTimeout(() => {
          setContextCardLoader({ cardId: '' });
        }, 100);
        orderViewModel.cartOpen = false;
        orderViewModel.save();
      }

    })
      .catch((e: { [key: string]: string }) => {
        if (e) {
          setContextCardLoader({ cardId: '' });
          setIsModal(true);
          setError(e);
        }
      });
  }

  return (
    <>
      {componentRenderCheck(
        isLoading,
        <Skeleton count={4} className={'single-slide'} flexContent={'row'} />,
      )}
      {!isLoading && <div className='menu-personalization' style={{ top: headerHeight }}>
        {dataNodeCount === 1 && activeData?.productsList?.length > 0 && <Heading
          level='h2'
          className='menu-personalization__heading'
          testAutoId='menu-personalization-heading'
          title={_get(activeData, 'title', '')}
        />}
        {dataNodeCount > 1 && <div className="fav_btn_seg" role='tablist'>
          {tabButtonData?.map((item: any, index: number) => {
            if (!_isEmpty(item.title)) {
              return (
                <ButtonSegments
                  buttonData={item}
                  key={item.title}
                  handleClick={() => {
                    handleTabClick(index);
                  }}
                  icon={!_isEmpty(item.icon) && <img
                    src={item.icon} alt='icon' />
                  }
                  isActive={activeIndex === index}
                />
              );
            }
          })}
        </div>}
        <CustomSlider
          slideCount={2}
          isFavoriteOrBestseller={true}
          slides={ternaryCheck(windowWidth > 1024,
            activeData?.productsList?.length, 1)}
          customBackBtnText={_get(activeData, ['dictionaryLables', 'previousForSlide'], 'Previous')}
          customDoneBtnText={_get(activeData, ['dictionaryLables', 'nextForSlide'], 'Done')}
          customNextBtnText={_get(activeData, ['dictionaryLables', 'nextForSlide'], 'Next')}
        >
          {renderCards(_get(activeData, ['productsList'], []))}
        </CustomSlider>
        {componentRenderCheck(
          multipleAndCheck(
            activeData?.categoryType !== RECOMMENDATIONS,
            _get(activeData, 'showViewAll', false)
          ),
          <div className={classNames('view-all-btn-div', {
            'up': activeData?.productsList?.length > 2,
          })}>
            {getViewAllBtn()}
          </div>)
        }

      </div>}
      {componentRenderCheck(
        multipleAndCheck(!_isEmpty(storeCloseOApopupData), showStoreCloseOApopup),
        <OrderAheadPopup
          showModal={showStoreCloseOApopup}
          modalData={storeCloseOApopupData as any}
          closePopup={storeCloseOApopupClose}
          name={"menu"}
        />)}
      {componentRenderCheck(
        isModal,
        <CartModal
          unavailableApiEndPoint={unavailableApiEndPoint}
          favDictonary={unavailableDictionary}
          unavailableData={Array.isArray(unavailableData) ? unavailableData : [unavailableData]}
          cartItemId={ternaryCheck(activeData?.categoryType === FAVORITES,
            item?.cartItemId,
            item?.orderId)}
          errorData={error}
          showModal={isModal}
          updateModal={onCloseCartModal}
          okText={'OK'}
          siteName={siteName}
          orderViewModel={orderViewModel}
          storeClose={storeClose}
          language={orderViewModel.headerFooterLanguageCode}
          productName={item?.productName}
          {...(activeData?.categoryType !== FAVORITES) && {
            showOnlyReorderShoppingCTA: orderViewModel?.currentOrder?.cartQuantity > 0,
            showOnlyReorderStartCTA: orderViewModel?.currentOrder?.cartQuantity <= 0
          }}
          value="menu"
          addToBagSource={'menu'}
          isItemAvailable={isItemAvailable}
          deliveryAddress={deliveryAddress}
          isRecentOrderPage={activeData?.categoryType !== FAVORITES}
          itemsData={item}
        />,
      )}
      {componentRenderCheck(!_isEmpty(errorOrderHistoryList),
        <InfoModal error={errorOrderHistoryList} okText={window.okText} value={'menu'} />
      )}
    </>
  );
};
export default MenuPersonalization;
